import { z } from "zod";

import { baseApiResponse } from "./BaseApiResponse";

export const userTransactionResolver = z.object({
	ID: z.string(),
	System: z.string(),
	Amount: z.number().or(z.string()),
	AmountEur: z.number().or(z.string()),
	Status: z.number(),
	Note: z.string(),
	Date: z.string(),
	DateISO: z.string(),
	Currency: z.string(),
	Wallet: z.string().optional(),
	AllowCancellation: z.number().optional()
});

export type UserTransactionModel = z.infer<typeof userTransactionResolver>;

export const listUserTransactionsResult = baseApiResponse.extend({
	data: userTransactionResolver.array()
});

export type ListUserTransactionsResult = z.infer<typeof listUserTransactionsResult>;
